module.exports = __webpack_public_path__ + "img/spotify_icon.7a34cf42.png";